import CommonStyles from "../../../../styles/CommonStyles.css";
import PreviewStylesCss from "../../../../styles/PreviewStyles.css";

export const styles = (theme) => ({
    ...CommonStyles,
    ...PreviewStylesCss,
 
    TooltipContentWrap:{
      padding:"10px",
      "& img":{
        width:"100%",
        height:"auto",
      }
    },
    categoryType:{
      display:"block",
      fontSize:" 0.88em",
      color: "#e0c548",
    },
    muListWrap: {
      padding: " 20px 30px",
      height: "calc(100% - 190px)",
      overflow: "auto",
      position: "absolute",
      width: "100%",
      top: "0",
      overflowX: "hidden",
      background: " #353535",
   
      
    },
   
    
   
    
   
})